import React, { useState } from "react";
import Input from "../../inputs/Input";
import Modal from "../../modal/Modal";
import Dropdown from "../../inputs/Dropdown";
import RadioBtn from "../../radio/RadioBtn";
import { DeleteIcon, Radio } from "../../../utils/utils";
import { Alerts } from "../../Alerts/Alerts";
import { AddButton, SaveButton } from "../../btn/Buttons";
import Table from "../../table/Table";
import { useSelector } from "react-redux";
import useUniqueEquipmentList from "../../../utils/Hook/useUniqueEquipmentList";
import { staffMasterAPI, staffMasterAPI2 } from "../../../utils/apis";
import { toast } from "react-toastify";
import store from "../../../redux/store";
import { get_staff_list } from "../../../screens/MasterData/masterdataSlice";
import axios from "axios";
import { EmailValidation, MobileValidation } from "../../../utils/validator";
import {
  setLoadingMain,
  setMessAlert,
  setOpenAlert,
} from "../../../redux/slice/actionSlice";
import { NumberDecimalEntry, OnlyNumberEntry } from "../../../utils/OtherFuncs";
import moment from "moment";
import SmallModal from "../../modal/SmallModal";

const UpdateStaffMaster = ({
  open,
  setOpen,
  EditItem,
  setEditItem,
  data,
  flag,
  setFlag,
  obj,
}) => {
  const { user_id, emp_id } = useSelector((state) => state.other);
  const [isOpen, setIsOpen] = useState(false);
  const { equipment_list, staff_list } = useSelector(
    (state) => state.masterdata
  );

  const uniqueEquipmentList = useUniqueEquipmentList(equipment_list);

  const update = async (type) => {
    const validationErrors = data
      ? validateCommission(flag ? "commission" : "salary")
      : valiDateEdit();

    if (!data && type != "modal" && !EditItem.OUTSTANDING_FLAG) {
      setIsOpen(true);
      return;
    }else{
      setIsOpen(false);
    }

    

    if (validationErrors?.length > 0) {
      return showError(validationErrors);
    }

    try {
      store.dispatch(setLoadingMain(true));
      if (data) {
        await handleSalaryOrCommissionUpdate();
      } else {
        await handlePersonalDetailsUpdate();
      }
    } catch (error) {
      console.log(error);
    } finally {
      store.dispatch(setLoadingMain(false));
    }
  };

  const SuccessFunction = () => {
    setOpen(false);
    setEditItem({});
    store.dispatch(get_staff_list(obj));
  };

  const showError = (messages) => {
    store.dispatch(setOpenAlert(true));
    store.dispatch(setMessAlert(messages));
  };

  const handleSalaryOrCommissionUpdate = async () => {
    const body = {
      agencyid: user_id,
      action: "saveOrUpdateStaffSalaryData",
      empid: EditItem?.ID,
      staffrole: flag ? "1" : "0",
      staff_id: EditItem?.ID,
      staff_type: flag ? 1 : 0,
      basicpay: !flag ? EditItem?.BASIC_PAY : 0,
      hra: !flag ? EditItem?.HRA : 0,
      conveyance: !flag ? EditItem?.CONVEYANCE_ALLOWANCE : 0,
      mallowance: !flag ? EditItem?.MEDICAL_ALLOWANCE : 0,
      oallowance: EditItem?.OTHER_ALLOWANCE,
      deliveryboytype: flag ? "1" : "0",
      commission_products: flag ? EditItem.COMMISSION_DATA : [],
    };

    const response = await staffMasterAPI2(body);
    if (response.success) {
      SuccessFunction();
    } else if (!response.success) return showError(response.message);
    toast(response.message, { position: "top-center" });
  };

  const handlePersonalDetailsUpdate = async () => {
    const body = new FormData();
    const append = (key, value) => value != null && body.append(key, value);

    append("action", "update");
    append("agencyid", user_id);
    append("id", EditItem?.ID);
    append("addhar", EditItem?.AADHAR);
    append("pan", EditItem?.PAN || "");
    append("bank_account", EditItem?.BANK_ACC_NO || "");
    EditItem?.BANK_ACC_NO && append("ifsc_code", EditItem?.IFSC_CODE);

    append("esic", EditItem?.ESIC_ELIGIBLE == 1 ? EditItem?.ESIC : "");
    append("contact_num", EditItem?.CONTACT_NO);
    append("pfnum", EditItem?.PF_ELIGIBLE == 1 ? EditItem?.PF_NUM : "");
    append("uan_num", EditItem?.UAN_NUM || "");
    append("blood_group", EditItem?.BLOOD_GROUP || "");
    append("emer_mob", EditItem?.EMERGENCY_CONTACT_NO || "");
    append("email_id", EditItem?.EMAIL_ID || "");
    append("address", EditItem?.ADDRESS?.trim());
    append("esic_eligible", EditItem?.ESIC_ELIGIBLE);
    append("pf_eligible", EditItem?.PF_ELIGIBLE);
    append("is_contract", EditItem?.IS_CONTRACT);
    append("pt_eligible", EditItem?.PT_ELIGIBLE);
    EditItem?.PT_ELIGIBLE &&
      append("prof_tax_amount", EditItem?.PROFESSIONAL_TAX_AMOUNT);
    append("tds_eligible", EditItem?.TDS_ELIGIBLE);
    if (EditItem?.TDS_ELIGIBLE) {
      append("tds_section", EditItem?.TDS_SECTION);
      append("tds_percentage", EditItem?.TDS_PERCENTAGE);
    }
    emp_id && append("emp_code", emp_id);

    if (!EditItem?.OUTSTANDING_FLAG) {
      const today = moment().format("YYYY-MM-DD");
      append("op_outstanding_advance", EditItem?.OP_OUTSTANDING_ADVANCE);
      append(
        "op_outstanding_advance_date",
        EditItem?.OP_OUTSTANDING_ADVANCE_DATE || today
      );
      append("op_outstanding_loans", EditItem?.OP_OUTSTANDING_LOANS);
      append(
        "op_outstanding_loans_date",
        EditItem?.OP_OUTSTANDING_LOAN_DATE || today
      );
      append("loan_months", EditItem?.OP_OUSTSTANDING_LOAN_MONTHS);
    }
    const response = await axios.post(staffMasterAPI, body);
    if (response.data.success) {
      SuccessFunction();
    } else if (!response.data.success) {
      return showError(response.data.message);
    }
    toast(response.data.message, { position: "top-center" });
  };

  const valiDateEdit = () => {
    const error = [];
    if (!data) {
      if (!EditItem?.AADHAR) {
        error.push(`Please Enter Aadhar Number`);
      } else if (EditItem?.AADHAR?.length !== 12) {
        error.push(`Invalid Aadhar`);
      }
      if (!EditItem?.PAN && EditItem?.TDS_ELIGIBLE) {
        error.push(`Pan Number is required if TDS Applicable`);
      } else if (
        EditItem?.PAN &&
        (EditItem?.PAN?.length !== 10 ||
          !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(EditItem?.PAN))
      ) {
        error.push(`Please Enter Valid Pan Number`);
      }

      if (
        EditItem?.BANK_ACC_NO &&
        (EditItem?.BANK_ACC_NO?.length < 11 ||
          EditItem?.BANK_ACC_NO?.length > 20)
      ) {
        error.push(`Please Enter Valid Bank Account No.`);
      }
      if (
        EditItem?.BANK_ACC_NO &&
        (!EditItem?.IFSC_CODE ||
          (EditItem?.IFSC_CODE && EditItem?.IFSC_CODE?.length == 0))
      ) {
        error.push(`Please Enter IFSC Code`);
      } else if (
        EditItem?.BANK_ACC_NO &&
        !/^[a-zA-Z0-9]{11}$/.test(EditItem?.IFSC_CODE)
      ) {
        error.push(`Please Enter Valid IFSC Code`);
      }

      if (!EditItem?.CONTACT_NO) {
        error.push(`Contact Number is required`);
      } else if (
        EditItem?.CONTACT_NO?.length !== 10 ||
        !MobileValidation.test(EditItem?.CONTACT_NO)
      ) {
        error.push(`Please Enter Valid Mobile Number`);
      }

      // if (EditItem?.PF_NUM && EditItem?.PF_NUM?.length !== 22) {
      //   error.push(`Please Enter Valid PF Number`);
      // }
      if (EditItem?.UAN_NUM && EditItem?.UAN_NUM?.length !== 12) {
        error.push(`Please Enter Valid UAN Number`);
      }
      if (
        EditItem?.EMERGENCY_CONTACT_NO &&
        EditItem?.EMERGENCY_CONTACT_NO != "" &&
        EditItem?.EMERGENCY_CONTACT_NO?.length !== 10 &&
        !MobileValidation.test(EditItem?.EMERGENCY_CONTACT_NO)
      ) {
        error.push(`Please Enter Valid EMERGENCY CONTACT Number`);
      }
      if (EditItem?.EMAIL_ID && !EmailValidation.test(EditItem?.EMAIL_ID)) {
        error.push(`Please Enter Valid Email`);
      }
      if (
        !EditItem?.ADDRESS ||
        (EditItem?.ADDRESS && EditItem?.ADDRESS?.trim()?.length == 0)
      ) {
        error.push(`Please Enter Address`);
      } else if (EditItem?.ADDRESS?.trim()?.length < 25) {
        error.push(`Address should be min 25 charactors`);
      }
      if (EditItem?.ESIC_ELIGIBLE == 1) {
        if (EditItem?.ESIC?.length == 0 || EditItem?.ESIC == null) {
          error.push(`Please Enter ESIC Number`);
        } else if (
          EditItem?.ESIC?.length <= 16 ||
          EditItem?.ESIC?.length >= 21
        ) {
          error.push(`Please Enter Valid ESIC Number`);
        }
      }
      if (EditItem?.PT_ELIGIBLE == 1) {
        if (
          !EditItem?.PROFESSIONAL_TAX_AMOUNT ||
          (EditItem?.PROFESSIONAL_TAX_AMOUNT &&
            EditItem?.PROFESSIONAL_TAX_AMOUNT?.trim()?.length == 0)
        ) {
          error.push(`Please Enter Professtion Tax`);
        }
      }
      if (EditItem?.TDS_ELIGIBLE == 1) {
        if (
          !EditItem?.TDS_SECTION ||
          (EditItem?.TDS_SECTION && EditItem?.TDS_SECTION?.trim()?.length == 0)
        ) {
          error.push(`Please Select TDS Section`);
        }
        if (
          !EditItem?.TDS_PERCENTAGE ||
          (EditItem?.TDS_PERCENTAGE &&
            EditItem?.TDS_PERCENTAGE?.trim()?.length == 0)
        ) {
          error.push(`Please Select Rate of TDS`);
        }
      }

      if (EditItem?.PF_ELIGIBLE == 1) {
        if (EditItem?.PF_NUM?.length == 0 || EditItem?.PF_NUM == null) {
          error.push(`Please Enter PF Number`);
        } else if (EditItem?.PF_NUM && EditItem?.PF_NUM?.length !== 22) {
          error.push(`Please Enter Valid PF Number`);
        }
      }

      if (EditItem?.IS_CONTRACT != 0 && EditItem?.IS_CONTRACT != 1) {
        error.push(`Please Select Employment Type`);
      }
    }
    if (!EditItem?.OUTSTANDING_FLAG) {
      // Validate Opening Advance Amount
      if (
        EditItem?.OP_OUTSTANDING_ADVANCE === undefined ||
        EditItem?.OP_OUTSTANDING_ADVANCE === null ||
        EditItem?.OP_OUTSTANDING_ADVANCE === ""
      ) {
        error.push(
          "Please enter Opening Advance Amount (enter 0 if not applicable)"
        );
      } else if (!NumberDecimalEntry(EditItem?.OP_OUTSTANDING_ADVANCE)) {
        error.push("Invalid Opening Advance Amount format");
      }

      // Validate Advance Date (required if amount > 0)
      if (
        parseFloat(EditItem?.OP_OUTSTANDING_ADVANCE) > 0 &&
        !EditItem?.OP_OUTSTANDING_ADVANCE_DATE
      ) {
        error.push(
          "Advance Date is required when Opening Advance Amount is more than 0"
        );
      } else if (
        EditItem?.OP_OUTSTANDING_ADVANCE_DATE &&
        moment(EditItem?.OP_OUTSTANDING_ADVANCE_DATE).isAfter(moment())
      ) {
        error.push("Advance Date cannot be a future date");
      }

      // Validate Opening Loan Amount
      if (
        EditItem?.OP_OUTSTANDING_LOANS === undefined ||
        EditItem?.OP_OUTSTANDING_LOANS === null ||
        EditItem?.OP_OUTSTANDING_LOANS === ""
      ) {
        error.push(
          "Please enter Opening Loan Amount (enter 0 if not applicable)"
        );
      } else if (!NumberDecimalEntry(EditItem?.OP_OUTSTANDING_LOANS)) {
        error.push("Invalid Opening Loan Amount format");
      }

      // Validate Loan Date (required if amount > 0)
      if (
        parseFloat(EditItem?.OP_OUTSTANDING_LOANS) > 0 &&
        !EditItem?.OP_OUTSTANDING_LOAN_DATE
      ) {
        error.push(
          "Loan Date is required when Opening Loan Amount is more than 0"
        );
      } else if (
        EditItem?.OP_OUTSTANDING_LOAN_DATE &&
        moment(EditItem?.OP_OUTSTANDING_LOAN_DATE).isAfter(moment())
      ) {
        error.push("Loan Date cannot be a future date");
      }

      // Validate No of Months (required if loan > 0)
      if (
        parseFloat(EditItem?.OP_OUTSTANDING_LOANS) > 0 &&
        (!EditItem?.OP_OUSTSTANDING_LOAN_MONTHS ||
          !OnlyNumberEntry(EditItem?.OP_OUSTSTANDING_LOAN_MONTHS, 2))
      ) {
        error.push(
          "Please enter valid No of Months for the Opening Loan Amount"
        );
      }
    }

    return error;
  };

  const validateCommission = (type) => {
    const error = [];
    if (type == "commission") {
      for (let v of EditItem?.COMMISSION_DATA) {
        if (!v?.PROD_CODE || (v?.PROD_CODE && v?.PROD_CODE.length === 0)) {
          error.push("Please Select PRODUCT ");
        }
        if (
          v?.COMMISSION_RATE === undefined ||
          v?.COMMISSION_RATE === null ||
          v?.COMMISSION_RATE === ""
        ) {
          error.push("Please Enter Commission Price");
        } else if (v?.discount_price < 0) {
          error.push("Commission cant be a negetive value");
        }
      }
    } else if (type == "salary") {
      if (!EditItem?.BASIC_PAY) {
        error.push("please enter Basic pay");
      } else if (EditItem?.BASIC_PAY == 0) {
        error.push("Basic pay cant be a negetive value");
      }
      if (!EditItem?.HRA) {
        error.push("please enter HRA");
      }
      if (!EditItem?.CONVEYANCE_ALLOWANCE) {
        error.push("please enter CONVEYANCE_ALLOWANCE");
      }
      if (!EditItem?.MEDICAL_ALLOWANCE) {
        error.push("please enter MEDICAL_ALLOWANCE");
      }
    }

    if (
      EditItem?.OTHER_ALLOWANCE === undefined ||
      EditItem?.OTHER_ALLOWANCE === null ||
      EditItem?.OTHER_ALLOWANCE === ""
    ) {
      error.push("Please Enter Other Allowance ");
    }
    return error;
  };

  const deleteProduct = async (item, ind) => {
    const filterData = EditItem?.COMMISSION_DATA.filter(
      (item, index) => index != ind
    );

    const update_item = () => {
      setEditItem({
        ...EditItem,
        COMMISSION_DATA: filterData,
      });
    };
    if (item?.ID) {
      const body = {
        action: "deleteCommissionProduct",
        agencyid: user_id,
        staff_id: EditItem?.ID,
        prod_code: item?.PROD_CODE,
        id: item?.ID,
      };
      const res = await staffMasterAPI2(body);
      if (res.success) {
        update_item();
      }
    } else {
      update_item();
    }
  };

  return (
    <Modal
      isOpen={open}
      setIsOpen={setOpen}
      title={"STAFF DETAILS"}
      body={
        <div className="flex column gap16">
          <div className="staff-heading">
            <div style={{ color: "#145272", fontWeight: "600" }}>
              PERSONAL INFO :
            </div>
            <div style={{ color: "#0c08d8", textWrap: "wrap" }}>
              {EditItem?.EMP_CODE} - {EditItem?.EMP_NAME}
            </div>
          </div>
          <div className="credit-limit gap10">
            <Input
              required={true}
              label={"AADHAR NUMBER"}
              placeholder={"AADHAR NUMBER"}
              value={EditItem?.AADHAR}
              disabled={
                staff_list?.filter((v) => v?.ID == EditItem?.ID)[0]?.AADHAR ||
                data
              }
              onChange={(e) => {
                const input = e.target.value;
                const sanitizedInput = input.replace(/\D/g, ""); // Remove non-digits
                const limitedInput = sanitizedInput.substring(0, 12); // Limit to 17 digits
                setEditItem({
                  ...EditItem,
                  AADHAR: limitedInput,
                });
              }}
            />
            <Input
              disabled={data}
              label={"PAN NUMBER"}
              placeholder={"PAN NUMBER"}
              value={EditItem?.PAN}
              onChange={(e) => {
                if (e.target.value?.length < 11) {
                  setEditItem({
                    ...EditItem,
                    PAN: e.target.value.toUpperCase(),
                  });
                }
              }}
            />
            <Input
              disabled={data}
              label={"BANK ACCOUNT"}
              placeholder={"BANK ACCOUNT"}
              value={EditItem?.BANK_ACC_NO}
              onChange={(e) => {
                const input = e.target.value;
                const sanitizedInput = input.replace(/\D/g, "");
                const limitedInput = sanitizedInput.substring(0, 20);
                setEditItem({
                  ...EditItem,
                  BANK_ACC_NO: limitedInput,
                  IFSC_CODE: limitedInput == "" ? "" : EditItem?.IFSC_CODE,
                });
              }}
            />
            {EditItem?.BANK_ACC_NO && (
              <Input
                disabled={data}
                value={EditItem.IFSC_CODE}
                onChange={(e) => {
                  const inputValue = e.target.value.toUpperCase();
                  if (
                    /^[a-zA-Z0-9]{0,11}$/.test(inputValue) ||
                    inputValue === ""
                  ) {
                    setEditItem({
                      ...EditItem,
                      IFSC_CODE: inputValue,
                    });
                  }
                }}
                placeholder={"IFSC CODE"}
                label={"IFSC CODE"}
              />
            )}
            <Input
              disabled={data}
              required={true}
              label={"CONTACT NUMBER"}
              value={EditItem?.CONTACT_NO}
              onChange={(e) => {
                const input = e.target.value;
                const sanitizedInput = input.replace(/\D/g, "");
                const limitedInput = sanitizedInput.substring(0, 10);
                setEditItem({
                  ...EditItem,
                  CONTACT_NO: limitedInput,
                });
              }}
              placeholder={"CONTACT NUMBER"}
            />
            <Input
              disabled={data}
              label={"UAN NUMBER"}
              placeholder={"UAN NUMBER"}
              value={EditItem?.UAN_NUM}
              onChange={(e) => {
                const input = e.target.value;
                const sanitizedInput = input.replace(/\D/g, "");
                const limitedInput = sanitizedInput.substring(0, 12);
                setEditItem({ ...EditItem, UAN_NUM: limitedInput });
              }}
            />
            <Dropdown
              width2=""
              disabled={data}
              label="BLOOD GROUP"
              value={EditItem?.BLOOD_GROUP}
              onChange={(e) => {
                setEditItem({ ...EditItem, BLOOD_GROUP: e.target.value });
              }}
              options={
                <>
                  <option hidden value={"0"}>
                    SELECT
                  </option>
                  <option value="1"> A + </option>
                  <option value="2"> A - </option>
                  <option value="3"> B + </option>
                  <option value="4"> B - </option>
                  <option value="5"> O + </option>
                  <option value="6"> O - </option>
                  <option value="7"> AB + </option>
                  <option value="8"> AB - </option>
                </>
              }
            />
            <Input
              disabled={data}
              value={EditItem?.EMERGENCY_CONTACT_NO}
              onChange={(e) => {
                const input = e.target.value;
                const sanitizedInput = input.replace(/\D/g, "");
                const limitedInput = sanitizedInput.substring(0, 10);
                setEditItem({
                  ...EditItem,
                  EMERGENCY_CONTACT_NO: limitedInput,
                });
              }}
              label={"EMERGENCY NUMBER"}
              placeholder={"EMERGENCY NUMBER"}
            />
            <Input
              disabled={data}
              value={EditItem?.EMAIL_ID}
              onChange={(e) => {
                setEditItem({ ...EditItem, EMAIL_ID: e.target.value });
              }}
              label={"EMAIL ID"}
              placeholder={"EMAIL ID"}
            />

            <Input
              disabled={data}
              value={EditItem?.ADDRESS}
              onChange={(e) => {
                setEditItem({ ...EditItem, ADDRESS: e.target.value });
              }}
              label={"ADDRESS"}
              required={true}
              placeholder={"ADDRESS"}
            />
            {/* {!EditItem?.OUTSTANDING_FLAG && (
              <> */}
            <Input
              disabled={EditItem?.OUTSTANDING_FLAG || data}
              value={EditItem?.OP_OUTSTANDING_ADVANCE}
              onChange={(e) => {
                const value = e.target.value;
                if (
                  (value?.length <= 10 && NumberDecimalEntry(value)) ||
                  value === "" ||
                  value === "-"
                ) {
                  setEditItem({
                    ...EditItem,
                    OP_OUTSTANDING_ADVANCE: value,
                  });
                }
              }}
              label={"OPENING ADVANCE AMT."}
              placeholder={"OPENING ADVANCE AMT."}
            />
            <Input
              disabled={EditItem?.OUTSTANDING_FLAG || data}
              label={"ADVANCE DATE"}
              placeholder={"ADVANCE DATE"}
              type={"date"}
              max={moment(new Date()).format("YYYY-MM-DD")}
              value={EditItem?.OP_OUTSTANDING_ADVANCE_DATE}
              onChange={(e) => {
                const value = e.target.value;
                if (value?.length == 10) {
                  setEditItem({
                    ...EditItem,
                    OP_OUTSTANDING_ADVANCE_DATE: value,
                  });
                }
              }}
            />

            <Input
              disabled={EditItem?.OUTSTANDING_FLAG || data}
              value={EditItem?.OP_OUTSTANDING_LOANS}
              onChange={(e) => {
                const value = e.target.value;
                if (
                  (value?.length <= 10 && NumberDecimalEntry(value)) ||
                  value === "" ||
                  value === "-"
                ) {
                  setEditItem({ ...EditItem, OP_OUTSTANDING_LOANS: value });
                }
              }}
              label={"OPENING LOAN AMT."}
              placeholder={"OPENING LOAN AMT."}
            />
            <Input
              disabled={EditItem?.OUTSTANDING_FLAG || data}
              label={"LOAN DATE"}
              placeholder={"LOAN DATE"}
              type={"date"}
              max={moment(new Date()).format("YYYY-MM-DD")}
              value={EditItem?.OP_OUTSTANDING_LOAN_DATE}
              onChange={(e) => {
                const value = e.target.value;
                if (value?.length == 10) {
                  setEditItem({
                    ...EditItem,
                    OP_OUTSTANDING_LOAN_DATE: value,
                  });
                }
              }}
            />
            <Input
              disabled={EditItem?.OUTSTANDING_FLAG || data}
              label="NO OF MONTHS"
              placeholder="NO OF MONTHS"
              type="number"
              min={1}
              value={EditItem?.OP_OUSTSTANDING_LOAN_MONTHS}
              onChange={(e) => {
                const value = e.target.value;
                if (
                  (value?.length <= 4 && OnlyNumberEntry(value, 2)) ||
                  value === ""
                ) {
                  setEditItem({
                    ...EditItem,
                    OP_OUSTSTANDING_LOAN_MONTHS: value,
                  });
                }
              }}
            />
            <div />
            <div
              className="flex column jcc aic gap16"
              style={{
                width: "240px",
                padding: " .15rem .5rem",
              }}
            >
              <div className="flex jcse gap16">
                <span>ESIC ELIGIBLE</span>
                <span>
                  <input
                    disabled={data}
                    className="cursor"
                    checked={
                      Number(EditItem?.ESIC_ELIGIBLE) == 0 ? false : true
                    }
                    onChange={(e) => {
                      setEditItem({
                        ...EditItem,
                        ESIC_ELIGIBLE:
                          Number(EditItem?.ESIC_ELIGIBLE) == 0 ? 1 : 0,
                      });
                    }}
                    type="checkbox"
                  />
                </span>
              </div>
              <div className="flex jcse gap16">
                <span>PF ELIGIBLE</span>
                <span style={{ paddingLeft: ".81rem" }}>
                  <input
                    disabled={data}
                    className="cursor"
                    checked={Number(EditItem?.PF_ELIGIBLE) == 0 ? false : true}
                    onChange={(e) => {
                      setEditItem({
                        ...EditItem,
                        PF_ELIGIBLE: Number(EditItem?.PF_ELIGIBLE) == 0 ? 1 : 0,
                      });
                    }}
                    type="checkbox"
                  />
                </span>
              </div>
            </div>
            <div
              className="flex column jcc aic gap16"
              style={{
                width: "240px",
                padding: " .15rem .5rem",
              }}
            >
              <div
                className="flex jcse gap16"
                style={{
                  flex: 1,
                  width: "100%",
                }}
              >
                <span>PROFESSIONAL TAX ELIGIBLE</span>
                <span>
                  <input
                    disabled={data}
                    className="cursor"
                    checked={Number(EditItem?.PT_ELIGIBLE) == 0 ? false : true}
                    onChange={(e) => {
                      setEditItem({
                        ...EditItem,
                        PT_ELIGIBLE: Number(EditItem?.PT_ELIGIBLE) == 0 ? 1 : 0,
                      });
                    }}
                    type="checkbox"
                  />
                </span>
              </div>
              <div
                className="flex jcsb gap16"
                style={{
                  flex: 1,
                  width: "100%",
                }}
              >
                <span>TDS ELIGIBLE</span>
                <span style={{ paddingLeft: ".81rem" }}>
                  <input
                    disabled={data}
                    className="cursor"
                    checked={Number(EditItem?.TDS_ELIGIBLE) == 0 ? false : true}
                    onChange={(e) => {
                      setEditItem({
                        ...EditItem,
                        TDS_ELIGIBLE:
                          Number(EditItem?.TDS_ELIGIBLE) == 0 ? 1 : 0,
                        TDS_SECTION: "",
                        TDS_PERCENTAGE: "",
                      });
                    }}
                    type="checkbox"
                  />
                </span>
              </div>
            </div>
            <div
              className="flex jcfs aic gap16"
              style={{
                marginTop: "1rem",
                width: "auto",
                padding: " .15rem .5rem",
              }}
            >
              <div className="flex aic gap10 ">
                <RadioBtn label={"EMPLYEEMENT TYPE"} />
                <Radio
                  disabled={data}
                  title={"CONTRACT BASE"}
                  show={EditItem?.IS_CONTRACT}
                  setShow={() =>
                    setEditItem({
                      ...EditItem,
                      IS_CONTRACT: 1,
                      TDS_SECTION: "194C",
                      TDS_PERCENTAGE: "1",
                    })
                  }
                />
                <Radio
                  disabled={data}
                  title={"FULL TIME"}
                  show={!EditItem?.IS_CONTRACT}
                  setShow={() =>
                    setEditItem({
                      ...EditItem,
                      IS_CONTRACT: 0,
                      TDS_SECTION: "192",
                      TDS_PERCENTAGE: "",
                    })
                  }
                />
              </div>
            </div>
          </div>

          <div className="credit-limit gap10">
            {EditItem?.ESIC_ELIGIBLE == 1 && (
              <Input
                disabled={data}
                required
                label={"ESIC NUMBER"}
                placeholder={"ESIC NUMBER"}
                value={EditItem?.ESIC}
                onChange={(e) => {
                  const input = e.target.value;
                  const sanitizedInput = input.replace(/\D/g, "");
                  if (e.target.value?.length <= 20) {
                    setEditItem({ ...EditItem, ESIC: sanitizedInput });
                  }
                }}
              />
            )}
            {EditItem?.PF_ELIGIBLE == 1 && (
              <Input
                required
                disabled={data}
                label={"PF NUMBER"}
                placeholder={"PF NUMBER"}
                value={EditItem?.PF_NUM}
                onChange={(e) => {
                  if (e.target.value?.length <= 22) {
                    setEditItem({ ...EditItem, PF_NUM: e.target.value });
                  }
                }}
              />
            )}
            {EditItem?.PT_ELIGIBLE == 1 && (
              <Input
                disabled={data}
                required
                label={"PROFESSIONAL TAX AMOUNT"}
                placeholder={"PROFESSIONAL TAX AMOUNT"}
                value={EditItem?.PROFESSIONAL_TAX_AMOUNT}
                onChange={(e) => {
                  const value = e.target.value;
                  if (
                    (value?.length <= 10 && NumberDecimalEntry(value)) ||
                    value === "" ||
                    value === "-"
                  ) {
                    setEditItem({
                      ...EditItem,
                      PROFESSIONAL_TAX_AMOUNT: e.target.value,
                    });
                  }
                }}
              />
            )}
            {EditItem?.TDS_ELIGIBLE == 1 && (
              <>
                <Dropdown
                  required
                  width2=""
                  disabled={data}
                  label="TDS Section"
                  value={EditItem?.TDS_SECTION}
                  onChange={(e) => {
                    setEditItem({ ...EditItem, TDS_SECTION: e.target.value });
                  }}
                  options={
                    <>
                      <option value={""}>SELECT</option>
                      {EditItem?.IS_CONTRACT == 1 ? (
                        <option value="194C">194C</option>
                      ) : (
                        <option value="192">192</option>
                      )}
                    </>
                  }
                />
                <Dropdown
                  width2=""
                  required
                  disabled={data}
                  label="Rate of TDS"
                  value={EditItem?.TDS_PERCENTAGE}
                  onChange={(e) => {
                    setEditItem({
                      ...EditItem,
                      TDS_PERCENTAGE: e.target.value,
                    });
                  }}
                  options={
                    <>
                      <option value={""}>SELECT</option>
                      <option value={"1"}>1 %</option>
                      {EditItem?.IS_CONTRACT == 0 && (
                        <>
                          {[2, 5, 10, 20].map((val) => (
                            <option value={val}>{val} %</option>
                          ))}
                        </>
                      )}
                    </>
                  }
                />
              </>
            )}
          </div>
          {data && (
            <>
              <div className="staff-heading">
                <div style={{ color: "#145272", fontWeight: "600" }}>
                  SALARY DETAILS
                </div>
                <div
                  className="flex gap16 aic wrap"
                  style={{
                    color: "#0c08d8",
                    textWrap: "wrap",
                  }}
                >
                  {EditItem?.role_id == 0 && (
                    <>
                      <div className="flex gap10">
                        <input
                          type="radio"
                          checked={EditItem?.STAFF_TYPE == 0}
                          onClick={() => {
                            setFlag(false);
                            setEditItem({ ...EditItem, STAFF_TYPE: 0 });
                          }}
                        />
                        <div
                          style={{
                            color: "#145272",
                            fontWeight: "600",
                            fontSize: "18px",
                          }}
                        >
                          Salary
                        </div>
                      </div>
                      <div className="flex gap10">
                        <input
                          type="radio"
                          checked={EditItem?.STAFF_TYPE == 1}
                          onClick={() => {
                            setFlag(true);
                            setEditItem({ ...EditItem, STAFF_TYPE: 1 });
                          }}
                        />
                        <div
                          style={{
                            color: "#145272",
                            fontWeight: "600",
                            fontSize: "18px",
                          }}
                        >
                          Commision
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="credit-limit ">
                {(!flag || EditItem?.STAFF_TYPE == 0) && (
                  <>
                    <Input
                      label={
                        <span>
                          BASIC PAY<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      placeholder={"BASIC PAY"}
                      value={EditItem?.BASIC_PAY}
                      onChange={(e) => {
                        if (e.target.value?.length < 11) {
                          const input = e.target.value;
                          const sanitizedInput = input.replace(/\D/g, "");
                          const limitedInput = sanitizedInput.substring(0, 20);
                          setEditItem({
                            ...EditItem,
                            BASIC_PAY: limitedInput,
                          });
                        }
                      }}
                    />
                    <Input
                      label={
                        <span>
                          HOUSE RENTAL ALLOWANCE
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      placeholder={"HOUSE RENTAL ALLOWANCE"}
                      value={EditItem?.HRA}
                      onChange={(e) => {
                        const input = e.target.value;
                        const sanitizedInput = input.replace(/\D/g, "");
                        const limitedInput = sanitizedInput.substring(0, 20);
                        setEditItem({
                          ...EditItem,
                          HRA: limitedInput,
                        });
                      }}
                    />
                    <Input
                      label={
                        <span>
                          CONVEYANCE ALLOWANCE
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      placeholder={"CONVEYANCE ALLOWANCE"}
                      value={EditItem?.CONVEYANCE_ALLOWANCE}
                      onChange={(e) => {
                        const input = e.target.value;
                        const sanitizedInput = input.replace(/\D/g, "");
                        const limitedInput = sanitizedInput.substring(0, 20);
                        setEditItem({
                          ...EditItem,
                          CONVEYANCE_ALLOWANCE: limitedInput,
                        });
                      }}
                    />
                    <Input
                      label={
                        <span>
                          MEDICAL ALLOWANCE
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      value={EditItem?.MEDICAL_ALLOWANCE}
                      onChange={(e) => {
                        const input = e.target.value;
                        const sanitizedInput = input.replace(/\D/g, "");
                        const limitedInput = sanitizedInput.substring(0, 10);
                        setEditItem({
                          ...EditItem,
                          MEDICAL_ALLOWANCE: limitedInput,
                        });
                      }}
                      placeholder={"MEDICAL ALLOWANCE"}
                    />
                  </>
                )}
                <Input
                  label={
                    <span>
                      OTHER ALLOWANCE
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder={"OTHER ALLOWANCE"}
                  value={EditItem?.OTHER_ALLOWANCE}
                  onChange={(e) => {
                    const input = e.target.value;
                    const sanitizedInput = input.replace(/\D/g, "");
                    const limitedInput = sanitizedInput.substring(0, 20);
                    setEditItem({
                      ...EditItem,
                      OTHER_ALLOWANCE: limitedInput,
                    });
                  }}
                />
              </div>

              {(flag || EditItem?.STAFF_TYPE == 1) &&
                EditItem?.role_id == 0 && (
                  <div>
                    <div>
                      <Table
                        nodata={EditItem?.COMMISSION_DATA?.length == 0}
                        headData={["PRODUCT", "Commission Amt.", "ACTIONS"]}
                        body={
                          EditItem?.COMMISSION_DATA?.length > 0
                            ? EditItem?.COMMISSION_DATA?.map((val, ind) => (
                                <tr key={ind}>
                                  <td>
                                    <Dropdown
                                      value={val?.PROD_CODE}
                                      onChange={(e) => {
                                        const selectedProduct =
                                          uniqueEquipmentList.find(
                                            (product) =>
                                              product?.PROD_CODE ==
                                              e.target.value
                                          );
                                        const updatedDetails = [
                                          ...EditItem?.COMMISSION_DATA,
                                        ];
                                        updatedDetails[ind] = {
                                          ...updatedDetails[ind],
                                          PROD_CODE: e.target.value,
                                          PROD_NAME: selectedProduct
                                            ? `${selectedProduct.CAT_NAME} ${selectedProduct.product_name}`
                                            : "",
                                          CAT_TYPE: selectedProduct
                                            ? selectedProduct?.CAT_NAME ==
                                              "DOMESTIC"
                                              ? 1
                                              : selectedProduct?.CAT_NAME ==
                                                "COMMERCIAL"
                                              ? 2
                                              : ""
                                            : "",
                                        };
                                        setEditItem({
                                          ...EditItem,
                                          COMMISSION_DATA: updatedDetails,
                                        });
                                      }}
                                      options={
                                        <>
                                          <option hidden value={"0"}>
                                            SELECT
                                          </option>
                                          {uniqueEquipmentList
                                            ?.filter(
                                              (v, i) =>
                                                v?.CAT_NAME != "REGULATOR"
                                            )
                                            ?.map((item, i) => (
                                              <option
                                                disabled={
                                                  EditItem?.COMMISSION_DATA?.some(
                                                    (v) =>
                                                      v?.PROD_CODE ==
                                                      item?.PROD_CODE
                                                  )
                                                    ? true
                                                    : false
                                                }
                                                key={i}
                                                value={item?.PROD_CODE}
                                              >
                                                {item.CAT_NAME}-
                                                {item.product_name}
                                              </option>
                                            ))}
                                        </>
                                      }
                                    />
                                  </td>
                                  <td>
                                    {
                                      <Input
                                        value={val?.COMMISSION_RATE}
                                        // placeholder={"DISCOUNT ON UNIT PRICE"}
                                        placeholder={
                                          "Commission Per Unit Price"
                                        }
                                        onChange={(e) => {
                                          const inputValue = e.target.value;
                                          const rejexValue =
                                            /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(
                                              inputValue
                                            );
                                          if (
                                            (inputValue?.length < 11 &&
                                              rejexValue) ||
                                            inputValue == 0 ||
                                            !val?.COMMISSION_RATE
                                          ) {
                                            const updatedDetails = [
                                              ...EditItem?.COMMISSION_DATA,
                                            ];
                                            updatedDetails[ind] = {
                                              ...updatedDetails[ind],
                                              COMMISSION_RATE: e.target.value,
                                            };
                                            setEditItem({
                                              ...EditItem,
                                              COMMISSION_DATA: updatedDetails,
                                            });
                                          }
                                        }}
                                      />
                                    }
                                  </td>
                                  <td>
                                    <DeleteIcon
                                      onClick={() => deleteProduct(val, ind)}
                                    />
                                  </td>
                                </tr>
                              ))
                            : ""
                        }
                      />
                    </div>
                  </div>
                )}
            </>
          )}
          <div
            className="flex aic jce"
            style={{
              fontSize: "11px",
              marginTop: "1rem",
              gap: ".5rem",
            }}
          >
            {data && (
              <>
                {flag && (
                  <AddButton
                    onClick={() => {
                      const data = validateCommission("commission");
                      if (data?.length == 0) {
                        setEditItem({
                          ...EditItem,
                          COMMISSION_DATA: EditItem?.COMMISSION_DATA?.concat(
                            {}
                          ),
                        });
                      } else {
                        store.dispatch(setOpenAlert(true));
                        store.dispatch(setMessAlert(data));
                      }
                    }}
                  />
                )}
              </>
            )}

            <SaveButton onClick={() => update("")} />
          </div>

          {isOpen && (
            <SmallModal
              title={"Confirm"}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              okBtnText={"SAVE"}
              okbtn
              mess={
                "Please ensure that previous loan and advance amounts, along with their effective dates, are provided. If not applicable, the amounts will be recorded as 0 and made non-editable."
              }
              ok_btn_click={() => update("modal")}
            />
          )}
        </div>
      }
    />
  );
};

export default UpdateStaffMaster;
